export default "__VITE_ASSET__DQUjlDVb__"